/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ModerationCreateReport from '../../../com/atproto/moderation/createReport.defs'
import * as AdminDefs from '../../../com/atproto/admin/defs.defs'
import * as RepoStrongRef from '../../../com/atproto/repo/strongRef.defs'
import * as InboxDefs from './defs.defs'

const $nsid = 'tools.ozone.inbox.appealActionedSubject'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  action: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.typedUnion(
      [
        /*#__PURE__*/ l.typedRef<ActionRef>((() => actionRef) as any),
        /*#__PURE__*/ l.typedRef<LabelRef>((() => labelRef) as any),
        /*#__PURE__*/ l.typedRef<TakedownRef>((() => takedownRef) as any),
      ],
      true,
    ),
  ),
  reason: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.string({ maxLength: 20000, maxGraphemes: 2000 }),
  ),
  modTool: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<ModerationCreateReport.ModTool>(
      (() => ModerationCreateReport.modTool) as any,
    ),
  ),
  subject: /*#__PURE__*/ l.typedUnion(
    [
      /*#__PURE__*/ l.typedRef<AdminDefs.RepoRef>(
        (() => AdminDefs.repoRef) as any,
      ),
      /*#__PURE__*/ l.typedRef<RepoStrongRef.Main>(
        (() => RepoStrongRef.main) as any,
      ),
    ],
    false,
  ),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.payload(
  'application/json',
  /*#__PURE__*/ l.ref<InboxDefs.SubjectView>(
    (() => InboxDefs.subjectView) as any,
  ),
)

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Appeal a moderation action affecting the user's account or content. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidAppealSubject',
  'AlreadyAppealed',
  'NotAppealable',
  'AppealWindowExpired',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }

type LabelRef = {
  $type?: 'tools.ozone.inbox.appealActionedSubject#labelRef'

  /**
   * Label being appealed.
   */
  val: string
}

export type { LabelRef }

const labelRef = /*#__PURE__*/ l.typedObject<LabelRef>(
  $nsid,
  'labelRef',
  /*#__PURE__*/ l.object({ val: /*#__PURE__*/ l.string({ minLength: 1 }) }),
)

export { labelRef }

type ActionRef = {
  $type?: 'tools.ozone.inbox.appealActionedSubject#actionRef'

  /**
   * ID of the moderation action being appealed, available via actions in mod inbox.
   */
  id: number
}

export type { ActionRef }

const actionRef = /*#__PURE__*/ l.typedObject<ActionRef>(
  $nsid,
  'actionRef',
  /*#__PURE__*/ l.object({ id: /*#__PURE__*/ l.integer({ minimum: 1 }) }),
)

export { actionRef }

type TakedownRef = {
  $type?: 'tools.ozone.inbox.appealActionedSubject#takedownRef'
}

export type { TakedownRef }

const takedownRef = /*#__PURE__*/ l.typedObject<TakedownRef>(
  $nsid,
  'takedownRef',
  /*#__PURE__*/ l.object({}),
)

export { takedownRef }
